import { useEffect, useState } from "react";

// Fetches Vimeo thumbnails via Vimeo's public CORS-enabled oEmbed endpoint.
// Falls back to the reel's `poster` field on error.
export function useVimeoPosters(reels) {
  const [posters, setPosters] = useState({});

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const entries = await Promise.all(
        reels.map(async (r) => {
          if (!r.sourceUrl) return [r.id, r.poster];
          try {
            const res = await fetch(
              `https://vimeo.com/api/oembed.json?url=${encodeURIComponent(
                r.sourceUrl
              )}&width=1280`
            );
            if (!res.ok) return [r.id, r.poster];
            const data = await res.json();
            // Upsize the thumbnail (Vimeo returns _640; swap for _1280)
            let url = data.thumbnail_url || r.poster;
            url = url.replace(/_\d+x\d+/, "_1280x720");
            return [r.id, url];
          } catch {
            return [r.id, r.poster];
          }
        })
      );

      if (!cancelled) {
        setPosters(Object.fromEntries(entries));
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [reels]);

  return posters;
}
